import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impact Details',
      type: 'details',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.change.impact',
            },
          },
        ],
      },
      content: {
        '{}': {
          sections: {
            '@': 'changeImpactSections',
          },
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              name: 'Edit',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'edit.change.impact.modal',
                        },
                      },
                      variables: {
                        '{}': {
                          changeImpactId: {
                            '@$': 'changeImpactId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    changeImpactId: '?1',
  },
  subqueries: {
    changeImpactSections: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'changeImpactId',
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              name: 'Overview',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Impact ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Change Impact Title',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'functionalArea',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Workstream',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_functional_area',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!functional_area',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'type',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Type',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_type',
                                  isMultiselect: true,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!type',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'phase',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Phase/Epic',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_phase',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!phase',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'sprint',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Sprint',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_sprint',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!sprint',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'targetGoLiveDate',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Date',
                              type: 'DATE',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!target_go_live_date',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 4,
            },
          },
          {
            '{}': {
              name: 'Description',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'description',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: "What's Changing Summary",
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!descr',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Status',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'status',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!change_impacts#!change_impact:!status',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!status',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'validationStatus',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Validation Status',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_validation_status',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!validation_status',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'priority',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!change_impacts#!change_impact:!priority',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!priority',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 3,
            },
          },
          {
            '{}': {
              name: 'Current and Future States',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'currentState',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Current State',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!current_state',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Future State',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'futureState',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Future State',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!future_state',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Impact Assessment',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'impactedGroups',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Department',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_department',
                                  isMultiselect: true,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!impacted_groups',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'degreeOfChange',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Degree of Change',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!degree_of_change',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'valueOfChange',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Value of Change',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!value_of_change',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'areaOfConcern',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Area of Concern',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!area_of_concern',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'keyBenefit',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Key Benefit',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!key_benefit',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 3,
            },
          },
          {
            '{}': {
              name: 'Readiness Needs',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'anticipatedResponseOfChange',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Anticipated Response of Change',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_anticipated_response',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!anticipated_response_of_change',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'communicationsNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communications Needed',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_yes_no_na',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!communications_needed',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'trainingImplications',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Implications',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_yes_no_na',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_implications',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'engagementsNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Engagements Needed',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!engagements_needed',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Notes',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'otherComments',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Other Comments',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!other_comments',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
        ],
      },
    },
  },
}
